
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, list_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ScanMatch_$reflection } from "../../Shared/Scan.js";
import { RequestedValue$1, FormState_get_empty, FormState__startLoading, RequestedValue$1_$reflection, FormState_$reflection } from "../../Shared/Shared.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { isNullOrEmpty, join, concat, isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { getScanResult } from "../../Requests/Scan.js";
import { ofArray, singleton, head, tail, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton as singleton_1, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { InventoryListModalSheet } from "../Modals/InventoryListModal.js";
import { Dialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { useZxing } from "react-zxing";
import { SubmitInput } from "../../Components/Input.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetInputValue", "FetchScanResult", "ScanResultFetched", "CloseDialog", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Dialogs.QRCodeDialog.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", list_type(ScanMatch_$reflection())]], [], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(OnClose, ScanInputValue, FormState, ScanResults) {
        super();
        this.OnClose = OnClose;
        this.ScanInputValue = ScanInputValue;
        this.FormState = FormState;
        this.ScanResults = ScanResults;
    }
}

function State_$reflection() {
    return record_type("Widgets.Dialogs.QRCodeDialog.State", [], State, () => [["OnClose", lambda_type(unit_type, unit_type)], ["ScanInputValue", string_type], ["FormState", FormState_$reflection()], ["ScanResults", RequestedValue$1_$reflection(list_type(ScanMatch_$reflection()))]]);
}

function update(msg, state) {
    let fullPath_2, fullPath_4, fullPath_6, fullPath_8, fullPath;
    switch (msg.tag) {
        case 3: {
            state.OnClose();
            return [state, Cmd_none()];
        }
        case 1: {
            const qrCodeId = msg.fields[0];
            if (isNullOrWhiteSpace(qrCodeId)) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.OnClose, state.ScanInputValue, FormState__startLoading(state.FormState), state.ScanResults), getScanResult(qrCodeId, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
            }
        }
        case 2: {
            const response = msg.fields[0];
            const nextState = new State(state.OnClose, state.ScanInputValue, FormState_get_empty(), state.ScanResults);
            if (!isEmpty(response)) {
                if (isEmpty(tail(response))) {
                    const matchValue = head(response).Type;
                    switch (matchValue) {
                        case "toolWithQuantity":
                            return [nextState, Cmd_batch(ofArray([(fullPath_2 = concat("/toolswithquantity/", ...head(response).Id), Cmd_ofEffect((_arg_1) => {
                                RouterModule_nav(singleton(fullPath_2), 1, 1);
                            })), singleton((dispatch_1) => {
                                dispatch_1(new Msg(3, []));
                            })]))];
                        case "consumable":
                            return [nextState, Cmd_batch(ofArray([(fullPath_4 = concat("/consumables/", ...head(response).Id), Cmd_ofEffect((_arg_2) => {
                                RouterModule_nav(singleton(fullPath_4), 1, 1);
                            })), singleton((dispatch_2) => {
                                dispatch_2(new Msg(3, []));
                            })]))];
                        case "set":
                            return [nextState, Cmd_batch(ofArray([(fullPath_6 = concat("/sets/", ...head(response).Id), Cmd_ofEffect((_arg_3) => {
                                RouterModule_nav(singleton(fullPath_6), 1, 1);
                            })), singleton((dispatch_3) => {
                                dispatch_3(new Msg(3, []));
                            })]))];
                        case "receiver":
                            return [nextState, Cmd_batch(ofArray([(fullPath_8 = concat("/receivers/", ...head(response).Id), Cmd_ofEffect((_arg_4) => {
                                RouterModule_nav(singleton(fullPath_8), 1, 1);
                            })), singleton((dispatch_4) => {
                                dispatch_4(new Msg(3, []));
                            })]))];
                        default:
                            return [nextState, Cmd_batch(ofArray([(fullPath = concat("/tools/", ...head(response).Id), Cmd_ofEffect((_arg) => {
                                RouterModule_nav(singleton(fullPath), 1, 1);
                            })), singleton((dispatch) => {
                                dispatch(new Msg(3, []));
                            })]))];
                    }
                }
                else {
                    return [new State(nextState.OnClose, nextState.ScanInputValue, nextState.FormState, new RequestedValue$1(1, [response])), Cmd_none()];
                }
            }
            else {
                return [nextState, Cmd_errorToast("general.no_entry_found_with_code")];
            }
        }
        case 4:
            return [new State(state.OnClose, state.ScanInputValue, FormState_get_empty(), state.ScanResults), Cmd_none()];
        default:
            return [new State(state.OnClose, msg.fields[0], state.FormState, state.ScanResults), Cmd_none()];
    }
}

function init(onClose) {
    return [new State(onClose, "", FormState_get_empty(), new RequestedValue$1(0, [])), Cmd_none()];
}

function ScannerDialog(props) {
    let elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton((elems_1 = toList(delay(() => {
        let matchValue;
        return append((matchValue = props.ScanResults, (matchValue.tag === 0) ? (empty()) : singleton_1(createElement(InventoryListModalSheet, {
            IsOpen: true,
            OnClose: props.OnClose,
            ScanResults: matchValue.fields[0],
        }))), delay(() => {
            let IsOpen, Title, elems;
            return singleton_1(createElement(Dialog, (IsOpen = ((props.ScanResults.tag === 0) && props.IsOpen), (Title = t("scan_qr_code_dialog.btn_text"), {
                Body: singleton(reactElement("div", createObj(ofArray([["data-test-id", "qr-code-dialog-body"], ["className", join(" ", ["justify-center", "rounded-lg", "w-[36rem]"])], (elems = [reactElement("video", {
                    ref: props.ZXing.ref,
                    poster: "assets/images/placeholder-image-light.png",
                    className: join(" ", ["justify-center", "rounded-lg"]),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))),
                Controls: singleton(createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("general.cancel"),
                    OnClick: props.OnClose,
                    TestId: "close-qr-code-dialog-test-id",
                    Variant: "blueButton",
                })),
                IsOpen: IsOpen,
                OnClose: props.OnClose,
                Title: Title,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

export function SearchQRCodeDialog(props) {
    const patternInput = reactApi.useState("");
    const setResult = patternInput[1];
    const result = patternInput[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const zxing = useZxing({
        onDecodeResult: (value) => {
            setResult(value.getText());
        },
        paused: !props.IsOpen ? true : state_1.FormState.IsLoading,
    });
    const dependencies_2 = [result, state_1.FormState.IsLoading];
    reactApi.useEffect(() => {
        const value_1 = result;
        if (!state_1.FormState.IsLoading && !isNullOrEmpty(value_1)) {
            patternInput_1[1](new Msg(1, [value_1]));
            setResult("");
        }
    }, dependencies_2);
    return createElement(ScannerDialog, {
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        ScanResults: state_1.ScanResults,
        ZXing: zxing,
    });
}

export function AssignQRCodeDialog(props) {
    return createElement(ScannerDialog, {
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        ScanResults: new RequestedValue$1(0, []),
        ZXing: useZxing({
            onDecodeResult: (value) => {
                props.OnQRCodeRead(value.getText());
                props.OnClose();
            },
            paused: !props.IsOpen,
        }),
    });
}

export function TextSearchQRCodeDialog(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["data-test-id", "search-qr-code-dialog-body"], (elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = state_1.ScanResults, (matchValue.tag === 0) ? (empty()) : singleton_1(createElement(InventoryListModalSheet, {
            IsOpen: true,
            OnClose: props.OnClose,
            ScanResults: matchValue.fields[0],
        }))), delay(() => {
            let IsOpen, Title;
            return singleton_1(createElement(Dialog, (IsOpen = ((state_1.ScanResults.tag === 0) && props.IsOpen), (Title = t("search_qr_code_dialog.title"), {
                Body: singleton(createElement(SubmitInput, {
                    ComponentState: componentState,
                    Label: t("search_qr_code_dialog.code"),
                    OnChange: (arg) => {
                        dispatch(new Msg(0, [arg]));
                    },
                    OnSubmit: () => {
                        dispatch(new Msg(1, [state_1.ScanInputValue]));
                    },
                    TestId: "",
                    Value: state_1.ScanInputValue,
                })),
                Controls: ofArray([createElement(TextButton, {
                    ComponentState: componentState,
                    Label: t("general.cancel"),
                    OnClick: props.OnClose,
                    TestId: "close-qr-code-dialog-test-id",
                    Variant: "blueButton",
                }), createElement(TextButton, {
                    ComponentState: componentState,
                    Label: t("general.search"),
                    OnClick: () => {
                        dispatch(new Msg(1, [state_1.ScanInputValue]));
                    },
                    TestId: "search-qr-code-dialog-test-id",
                    Variant: "blueButton",
                })]),
                IsOpen: IsOpen,
                OnClose: props.OnClose,
                Title: Title,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

